/**
 * Contato de suporte do ObraSync.
 *
 * Um lugar só para o número: site, app e portal usam este. Mudou o número,
 * muda aqui.
 */
export const SUPPORT_WHATSAPP_DIGITS = '551151234786';
export const SUPPORT_WHATSAPP_LABEL = '(11) 5123-4786';

/** Link do WhatsApp do suporte com a mensagem já escrita. */
export function supportWhatsappLink(text = 'Olá! Preciso de ajuda com o ObraSync.'): string {
	return `https://wa.me/${SUPPORT_WHATSAPP_DIGITS}?text=${encodeURIComponent(text)}`;
}
